module.exports = __webpack_public_path__ + "static/img/bg.1038e45.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg.png
// module id = fj4l
// module chunks = 0